<template>
  <StatRow>
    <StatRowItem
      data-testid="inCount"
      label="in"
      :modelValue="inCount"
      :aria-label="`${inCount} in`"
    />
    <StatRowItem
      v-bind="maybeWaitlistItem"
    />
    <StatRowItem
      v-if="pendingCount || !neededPlayerCount && !openSpotCount"
      data-testid="pendingCount"
      label="pending"
      :modelValue="pendingCount"
      :aria-label="`${pendingCount} pending`"
    />
    <StatRowItem
      v-if="neededPlayerItem"
      v-bind="neededPlayerItem"
    />
  </StatRow>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import StatRow from "./StatRow.vue";
import StatRowItem from "./StatRowItem.vue";

const {
  isCommish = false,
  inCount = 0,
  maybeCount = 0,
  openSpotCount = 0,
  neededPlayerCount = 0,
  waitlistCount = 0,
  pendingCount = 0,
} = defineProps<{
  isCommish?: boolean,
  inCount?: number,
  maybeCount?: number,
  openSpotCount?: number,
  neededPlayerCount?: number,
  waitlistCount?: number,
  pendingCount?: number,
}>();

const maybeWaitlistItem = computed(() => {
  if (maybeCount || !isCommish || !waitlistCount) {
    return {
      modelValue: maybeCount,
      "data-testid": "maybeCount",
      ariaLabel: `${maybeCount} maybe`,
      label: "maybe",
    };
  }

  return {
    modelValue: waitlistCount,
    "data-testid": "waitingCount",
    ariaLabel: `${waitlistCount} waiting`,
    label: "waiting",
  };
});

const neededPlayerItem = computed(() => {
  if (neededPlayerCount) {
    return {
      modelValue: neededPlayerCount,
      "data-testid": "neededCount",
      ariaLabel: `${neededPlayerCount} needed`,
      label: "needed",
    };
  } else if (openSpotCount) {
    const label = `${openSpotCount === 1 ? "spot" : "spots"} left`;

    return {
      modelValue: openSpotCount,
      "data-testid": "openSpotCount",
      ariaLabel: `${openSpotCount} ${label}`,
      label,
    };
  }

  return null;
});
</script>
